export default "__VITE_ASSET__DCJHJ6ji__"